var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#FFF2E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.503 10.3177V10.3166H34.403H15.5137C14.2335 10.3166 13.0066 10.8456 12.1025 11.7861C11.1986 12.7264 10.6916 14.0007 10.6916 15.3288V34.9783C10.6916 36.3064 11.1986 37.5808 12.1025 38.5211C13.0066 39.4615 14.2335 39.9905 15.5137 39.9905H34.403C35.6832 39.9905 36.9101 39.4615 37.8141 38.5211C38.7181 37.5808 39.2251 36.3064 39.2251 34.9783V15.3288C39.2251 14.0007 38.7181 12.7264 37.8141 11.7861C36.9337 10.8701 35.747 10.3445 34.503 10.3177ZM36.664 34.8782V34.9782C36.664 35.6043 36.4249 36.204 36.0003 36.6455L36.0003 36.6455C35.576 37.0871 35.0013 37.3342 34.403 37.3342H15.5137C14.9154 37.3342 14.3407 37.0871 13.9164 36.6455L13.9164 36.6455C13.4918 36.204 13.2528 35.6043 13.2528 34.9782V15.3287C13.2528 14.7027 13.4918 14.1029 13.9164 13.6614L13.9164 13.6614C14.3407 13.2198 14.9154 12.9727 15.5137 12.9727H34.403C35.0013 12.9727 35.576 13.2198 36.0003 13.6614L36.0003 13.6614C36.4249 14.1029 36.664 14.7027 36.664 15.3287L36.6641 34.8782H36.664Z",
    fill: "#2E0C31",
    stroke: "#2E0C31",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8775 19.8738L19.8775 19.8738C18.5309 21.2749 17.775 23.174 17.775 25.1534C17.775 27.1329 18.5309 29.032 19.8775 30.433L19.8775 30.433C21.2245 31.834 23.052 32.6218 24.9583 32.6218C26.8647 32.6218 28.6922 31.834 30.0392 30.433L30.0392 30.433C31.3858 29.032 32.1417 27.1329 32.1417 25.1534C32.1417 23.174 31.3858 21.2749 30.0392 19.8738L30.0392 19.8738C28.6922 18.4729 26.8647 17.685 24.9583 17.685C23.052 17.685 21.2245 18.4729 19.8775 19.8738ZM24.9583 29.9655C23.7337 29.9655 22.5585 29.4596 21.6913 28.5575C20.824 27.6553 20.3362 26.4309 20.3362 25.1533C20.3362 23.8758 20.824 22.6514 21.6913 21.7492C22.5585 20.8471 23.7337 20.3411 24.9583 20.3411C26.183 20.3411 27.3581 20.8471 28.2253 21.7492C29.0927 22.6514 29.5805 23.8758 29.5805 25.1533C29.5805 26.4309 29.0927 27.6553 28.2253 28.5575C27.3581 29.4596 26.183 29.9655 24.9583 29.9655Z",
    fill: "#2E0C31",
    stroke: "#2E0C31",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6322 19.1129C33.669 19.1129 34.503 18.2398 34.503 17.1708C34.503 16.1021 33.669 15.2287 32.6322 15.2287C31.5951 15.2287 30.7613 16.1021 30.7613 17.1708C30.7613 18.2398 31.5951 19.1129 32.6322 19.1129Z",
    fill: "#2E0C31",
    stroke: "#2E0C31",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.6169ea735149fa3b0c8c16bdaa7a0ba3.svg";
export { ForwardRef as ReactComponent };